/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analogous palettes feel calm because the hues are close together.`)
};

const es_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las paletas análogas transmiten calma porque los tonos están próximos entre sí.`)
};

const de_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analoge Paletten wirken ruhig, weil die Farbtöne nah beieinanderliegen.`)
};

const nl_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analoge paletten voelen rustig aan omdat de tinten dicht bij elkaar liggen.`)
};

const fr_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les palettes analogues paraissent apaisantes car les teintes sont proches les unes des autres.`)
};

const it_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le palette analoghe trasmettono calma perché le tonalità sono vicine tra loro.`)
};

const pt_br2_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paletas análogas transmitem calma porque os tons ficam próximos entre si.`)
};

const pt_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As paletas análogas transmitem calma porque os tons estão próximos entre si.`)
};

const ja_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類似色のパレットは色相が近いため落ち着いた印象になります。`)
};

const zh_cp_ex2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邻近色配色方案由于色相相近，给人以平和的感觉。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_ex2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_ex2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_ex2", locale)
	if (locale === "en") return en_cp_ex2(inputs)
	if (locale === "es") return es_cp_ex2(inputs)
	if (locale === "de") return de_cp_ex2(inputs)
	if (locale === "nl") return nl_cp_ex2(inputs)
	if (locale === "fr") return fr_cp_ex2(inputs)
	if (locale === "it") return it_cp_ex2(inputs)
	if (locale === "pt-BR") return pt_br2_cp_ex2(inputs)
	if (locale === "pt") return pt_cp_ex2(inputs)
	if (locale === "ja") return ja_cp_ex2(inputs)
	return zh_cp_ex2(inputs)
};